import React, { useMemo } from "react";

import {
  GetExperiencesListResponseBodyType,
  GetOffersExperienceListResponseType,
  PersonalizationTestType,
} from "@intelligems/ig-types";
import { sortByStatus } from "@intelligems/ig-utils";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import { BaseExperienceTable } from "@src/components/Table/BaseExperienceTable";
import { useSearchOffersData } from "@src/features/sharedExperience/tableUtils";
import { UseQueryResult } from "@tanstack/react-query";

interface SiteContentTableProps {
  personalizationData: UseQueryResult<
    GetExperiencesListResponseBodyType,
    Error
  >;
  searchInput: string;
  statusFilters: string[];
  typeFilters: PersonalizationTestType[];
}

export const SiteContentTable = ({
  personalizationData,
  typeFilters,
  statusFilters,
  searchInput,
}: SiteContentTableProps) => {
  const sortedAndFilteredRowData = useMemo(() => {
    if (!personalizationData.data?.experiencesList) return [];
    const siteContentPersonalizations =
      personalizationData.data?.experiencesList.filter(
        (personalization) =>
          personalization.testTypes.hasTestPricing ||
          personalization.testTypes.hasTestShipping ||
          personalization.testTypes.hasTestContentTheme ||
          personalization.testTypes.hasTestContentTemplate ||
          personalization.testTypes.hasTestContentUrl ||
          personalization.testTypes.hasTestContentOnsite ||
          personalization.testTypes.hasTestOnsiteInjections
      );
    return sortByStatus([...siteContentPersonalizations]).sort((a, b) => {
      if (!a || !b || !!a.archivedAtTs === !!b.archivedAtTs) {
        return 0;
      }
      return a.archivedAtTs ? 1 : -1;
    });
  }, [personalizationData.data?.experiencesList]);

  const searchedRowData = useSearchOffersData(
    sortedAndFilteredRowData,
    searchInput,
    typeFilters,
    statusFilters,
    "siteContent"
  );

  return (
    <BaseExperienceTable
      renderLocation={"siteContent"}
      rowData={searchedRowData}
      isLoading={personalizationData.isLoading}
    />
  );
};
